import { all } from 'redux-saga/effects';
import sectorSaga from './sector';

export default function* sectorModuleSaga() {
  yield all([sectorSaga()]);
}
